export interface UploadOptions {
  /**
   * Origin of the upload. `"sample"` opts the job out of quota accounting.
   * Defaults to `"dashboard"` when called from anywhere inside the app.
   */
  source?: "dashboard" | "hero" | "sample"
}

type UploadHandler = (file: File, options?: UploadOptions) => void

let handler: UploadHandler | null = null

// Last file + options the user tried to upload, kept so the status-card
// retry button can re-run the same job without forcing the user to pick
// the file again. Reset whenever the user explicitly clears it.
let lastFile:    File | null               = null
let lastOptions: UploadOptions | undefined = undefined

export function setUploadHandler(fn: UploadHandler) {
  handler = fn
}

export function triggerUpload(file: File, options?: UploadOptions) {
  if (!handler) return
  lastFile    = file
  lastOptions = options
  handler(file, options)
}

export function retryLastUpload(): boolean {
  if (!handler || !lastFile) return false
  handler(lastFile, lastOptions)
  return true
}

export function hasLastUpload(): boolean {
  return lastFile !== null
}

export function clearLastUpload() {
  lastFile    = null
  lastOptions = undefined
}
